<template>
  <div
    :class="{
      'service-item': true,
      'service-item-offline': item.status == 1,
      'service-item-hover': type == 'node',
      'service-item-search': type == 'search',
      'service-item-limit': index > max_index - 1,
    }"
    @click="chooseServiceClick(item, index)"
  >
    <div class="item-limit" v-if="index > max_index - 1"></div>
    <div class="item-content">
      <div
        class="item-del"
        @click="removeServiceClick(item, index)"
        v-if="mode == 'del' && !item.isFixed"
      ></div>
      <div class="item-name-group">
        <div class="item-bg-type">
          <div
            :class="{
              'item-icon-wrap-on': item.status != 1,
              'item-icon-wrap-off': item.status == 1,
            }"
          >
            <div
              v-if="item.icon"
              :class="{
                'other-icon': item.icon,
              }"
              :style="{
                'background-image': 'url(\'' + item.icon + '\')',
              }"
            >
              <!-- <div
                :class="{
                  'item-text-wrap-on': true,
                  'item-text-wrap-off': item.status == 1,
                }"
              ></div> -->
            </div>
            <div v-else :class="deviceClass(item.dtype, item.ports)">
              <!-- <div
                :class="{
                  'item-text-wrap-on': true,
                  'item-text-wrap-off': item.status == 1,
                }"
              ></div> -->
            </div>
          </div>
        </div>
        <div class="item-text">
          <div
            class="item-name"
            :title="
              item.uname
                ? item.uname
                : item.port_name
                ? item.port_name
                : item.name
            "
            v-if="!isShowNameEdit"
            @click="showNameEdit"
          >
            {{
              item.uname
                ? item.uname
                : item.port_name
                ? item.port_name
                : item.name
            }}
          </div>
          <div class="item-name-edit" v-else>
            <input
              v-model="name"
              id="name"
              @blur="saveNameEdit(item)"
              @keydown.enter="saveNameEdit(item)"
            />
          </div>
          <div class="item-ip" v-if="item.dtype == 998">
            <!-- <div class="item-ip-dot"></div> -->
            {{ item.mac ? item.mac.match(/.{2}/g).join(":") : "" }}
          </div>
          <div class="item-ip" v-else>
            <!-- <div class="item-ip-dot"></div> -->
            {{ $common.ipConvert(item.ip)
            }}{{ item.status == 1 ? "" : item.port ? ":" + item.port : "" }}
          </div>
        </div>

        <div class="item-type-text">远程{{ item.type_name }}</div>
      </div>
      <template v-if="mode != 'del'">
        <!--离线-->
        <template v-if="item.status == 1">
          <!--1nas 3winpc可开机-->
          <template v-if="item.dtype == 3 && item.port == 3389">
            <div class="remote-btn remote-btn-open" @click="openClick(item)">
              开机唤醒
              <div class="remote-btn-bg"></div>
            </div>
          </template>
          <!--其它类型置灰-->
          <template v-else>
            <div class="remote-btn remote-btn-unactive">
              {{ item.btn }}
            </div>
          </template>
        </template>
        <template v-if="item.dtype == 998">
          <div class="remote-btn remote-btn-open" @click="openClick(item)">
            开机唤醒
            <div class="remote-btn-bg"></div>
          </div>
        </template>
        <!--在线-->
        <template v-else>
          <template v-if="item.port">
            <div class="remote-btn" @click="controlClick(item)">
              {{ item.btn }}
              <div class="remote-btn-bg"></div>
            </div>
          </template>
        </template>
      </template>
    </div>
    <div
      v-if="type == 'search'"
      class="service-choose-icon"
      :class="{
        'service-choose-icon-unactive': uncheckList.indexOf(index) != -1,
      }"
    ></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: function () {
    return {
      name: "",
      isShowNameEdit: false,
    };
  },
  props: ["item", "index", "type", "uncheckList", "max_index", "mode"],
  methods: {
    ...mapActions(["sendUserlog"]),
    showNameEdit: function () {
      if (this.type != "node") {
        return;
      }
      if (this.item.isFixed) {
        return;
      }
      this.isShowNameEdit = true;
      setTimeout(function () {
        document.getElementById("name").focus();
      }, 500);
    },
    hideNameEdit: function () {
      this.isShowNameEdit = false;
    },
    saveNameEdit: function (item) {
      // console.log("saveNameEdit");
      // item.name = this.name;
      this.hideNameEdit();
      item.uname = this.name;
      this.$emit("nameEditClick", item);
    },
    controlClick: function (item) {
      // console.log("controlClick");
      let _that = this;
      if (_that.index > _that.max_index - 1) {
        // console.log("limitClick");
        _that.$emit("limitClick", item);
        _that.sendUserlog([
          "service_limit_control",
          _that.$store.state.user.vip_left > 0 ? 1 : 0,
        ]);
      } else {
        this.$emit("controlClick", item);
      }
    },
    openClick: function (item) {
      let _that = this;
      if (_that.index > _that.max_index - 1) {
        _that.$emit("limitClick");
        _that.sendUserlog([
          "service_limit_open",
          _that.$store.state.user.vip_left > 0 ? 1 : 0,
        ]);
      } else {
        _that.$emit("openClick", item);
      }
    },
    removeServiceClick: function (item, index) {
      this.$emit("removeServiceClick", item, index);
    },
    chooseServiceClick: function (item, index) {
      if (this.type != "search") {
        return;
      }
      this.$emit("chooseServiceClick", item, index);
    },
    deviceClass(deviceType, devicePorts) {
      if (deviceType === 1) {
        return "nas-icon"; // 手机设备图片路径
      } else if (deviceType === 2) {
        return "router-icon"; // 平板设备图片路径
      } else if (deviceType === 3 || deviceType === 999) {
        if (devicePorts.includes(5900)) {
          return "mac-icon";
        } else if (devicePorts.includes(3389)) {
          return "winpc-icon";
        } else {
          return "default-icon";
        }
      } else {
        return "default-icon";
      }
    },
  },
  mounted: function () {
    // console.log(this.item);
    this.name = this.item.uname
      ? this.item.uname
      : this.item.port_name
      ? this.item.port_name
      : this.item.name;
  },
};
</script>

<style lang="less" scoped>
.service-item {
  display: inline-block;
  position: relative;
  margin-left: 6px;
  margin-right: 6px;
  margin-top: 6px;
  margin-bottom: 6px;
  width: 290px;
  // width: 210px\0;
  height: 90px;
  box-sizing: border-box;
  //   background-color: #fcfdff;
  border-radius: 6px;
  border: 1px solid #d7deec;
  vertical-align: top;

  .item-bg-type {
    margin-left: 16px;
    margin-top: 3px;
    width: 48px;
    height: 48px;
    display: inline-block;
    vertical-align: top;
    border-radius: 32px;
  }

  .item-icon-wrap-on {
    width: 36px;
    height: 36px;
    margin-top: 0px;
    margin-left: 8px;
    .nas-icon,
    .other-icon,
    .router-icon,
    .winpc-icon,
    .mac-icon,
    .default-icon {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center;
    }
    .nas-icon {
      background-image: url("../../assets/home/node/nas_online.svg");
    }
    .router-icon {
      background-image: url("../../assets/home/node/router_online.svg");
    }
    .winpc-icon {
      background-image: url("../../assets/home/node/pc_online2.svg");
    }
    .mac-icon {
      background-image: url("../../assets/home/node/mac_online.svg");
    }
    .default-icon {
      background-image: url("../../assets/home/node/online_default.svg");
    }
  }

  .item-icon-wrap-off {
    width: 26px;
    height: 26px;
    margin-top: 8px;
    margin-left: 8px;
    .nas-icon,
    .other-icon,
    .router-icon,
    .winpc-icon,
    .mac-icon,
    .default-icon {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
    }
    .nas-icon {
      background-image: url("../../assets/home/node/nas_offline.svg");
    }
    .router-icon {
      background-image: url("../../assets/home/node/router_offline.svg");
    }
    .winpc-icon {
      background-image: url("../../assets/home/node/pc_offline2.svg");
    }
    .mac-icon {
      background-image: url("../../assets/home/node/mac_offline.svg");
    }
    .default-icon {
      background-image: url("../../assets/home/node/offline_default.svg");
    }
  }

  .item-limit {
    position: absolute;
    right: 27px;
    top: 40px;
    width: 24px;
    height: 24px;
    background-image: url(../../assets/home/node/node_service_limit.svg);
    background-size: 100% 100%;
  }

  .item-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .item-name-group {
    padding-top: 20px;
    z-index: 1;

    .item-type-text {
      display: none;
      background-color: #cad9fc;
      border-radius: 3px;
      font-size: 12px;
      width: 66px;
      height: 24px;
      line-height: 24px;
      margin-left: 8px;
      text-align: center;
      color: #1f5de3;
      margin-top: 5px;
      transform: scale(0.8);
      transform-origin: left;
    }

    .item-text {
      display: inline-block;
      vertical-align: top;
      margin-left: 8px;

      .item-name {
        width: 126px;
        color: #1b358b;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: bolder;
        height: 30px;
        line-height: 30px;
      }
      .item-name-edit {
        background-color: #ffffff;
        width: 120px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        border: 1px solid #eeeeee;
        box-shadow: 0px 0px 2px 0px #eeeeee;
        box-sizing: border-box;
        margin-left: -2px;
        input {
          color: #1b358b;
          font-weight: bolder;
          background-color: transparent;
          width: 110px;
          margin-left: 7px;
          height: 28px;
          line-height: 28px;
          font-size: 15px;
          margin-top: 0px;
          display: inline-block;
          vertical-align: top;
        }
      }
      .item-ip {
        font-size: 12px;
        color: #1f5de3;
        margin-top: 0px;
        height: 15px;
        line-height: 15px;
        .item-ip-dot {
          display: inline-block;
          vertical-align: top;
          width: 4px;
          height: 4px;
          background-color: #1f5de3;
          border-radius: 2px;
          margin-top: 5px;
        }
      }
    }
  }

  .remote-btn {
    width: 75px;
    height: 28px;
    color: #201e98;
    font-size: 13px;
    line-height: 28px;
    text-align: center;
    box-shadow: 0px 1px 2px 0px rgba(35, 13, 72, 0.16);
    // background-color: #cecff1;
    background-image: linear-gradient(
      189deg,
      rgba(108, 105, 254, 0.2) 0%,
      rgba(76, 73, 236, 0.2) 35.94%,
      rgba(41, 67, 157, 0.2) 99.24%
    );

    background-size: 100% 100%;
    border-radius: 18px;
    cursor: pointer;
    overflow: hidden;
    border-radius: 18px;

    position: absolute;
    right: 15px;
    top: 30px;
    .remote-btn-bg {
      display: none;
      background-color: #191e9f;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      animation-name: moveRight;
      animation-duration: 1.5s;
      animation-fill-mode: forwards;
      opacity: 0.2;
    }
  }
  .remote-btn:hover {
    background-color: #6c69fe;
    color: #ffffff;
    .remote-btn-bg {
      display: block;
    }
  }
  .remote-btn-unactive {
    background: #e5e7eb;
    color: #666666;
  }
  .remote-btn-unactive:hover {
    background: #cccccc;
  }
  .remote-btn-open {
    // background-image: none;
    // background-color: #1f5de3;
  }
  .remote-btn-open:hover {
    // background-image: none;
    // background-color: #477ef7;
  }

  .service-choose-icon {
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 36px;
    height: 36px;
    background-image: url("../../assets/home/node/find_icon22.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .service-choose-icon:hover {
    cursor: pointer;
  }
  .service-choose-icon-unactive {
    background-image: url("../../assets/home/node/find_icon11.png");
  }
}

.service-item.service-item-offline {
  background-color: #f6f6f6;
  border-color: #eaebea;

  .item-name-group {
    .item-text {
      .item-name {
        color: #666666;
      }

      .item-ip {
        color: #999999;
        .item-ip-dot {
          background-color: #999999;
        }
      }
    }
  }
}

.service-item.service-item-offline:hover {
  background-color: #f6f6f6;
}

.service-item:hover {
  border: 1px solid #3771ef;
  // box-shadow: 0 4px 16px 1px rgba(125, 91, 19, 0.56);
  box-shadow: 0px 4px 16px 1px rgba(121, 135, 165, 0.16);
  background-color: #edf3ff;
}

.service-item-hover,
.service-item-hover:hover {
  position: relative;

  .item-del {
    position: absolute;
    right: 8px;
    bottom: 8px;
    width: 20px;
    height: 20px;
    background-image: url("../../assets/home/node/del-btn.svg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
}

.service-item.service-item-search {
  background-color: #fcfdff;
  height: 100px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 8px;

  .item-text {
    .item-name {
      width: 150px;
    }
  }

  .item-bg {
    display: block;
    top: 13px;
    right: 25px;
    width: 75px;
    height: 75px;
    background-image: url(../../assets/home/node/node_item_bg3.svg);
    background-size: 100% 100%;
    background-position: center center;
    .item-bg-type {
      right: 22px;
      top: 22px;
    }
  }

  .item-name-group {
    padding-top: 15px;
  }

  .item-type-text {
    display: block;
  }

  .remote-btn {
    display: none;
  }
  .remote-btn:hover {
    background-color: #dbe5fb;
  }
}

.service-item.service-item-search:hover {
  background-color: #edf3ff;
}

.service-item.service-item-search.service-item-offline {
  background-color: #f6f6f6;

  .item-bg.item-bg-off {
    background-image: url(../../assets/home/node/node_item_offline_bg3.svg);
  }
  .item-type-text {
    background-color: #999999;
    color: #ffffff;
  }
}
.service-item.service-item-limit {
  .remote-btn {
    background-image: none;
    background-color: #1f5de3;
    background-image: url(../../assets/home/node/node_service_limit.png);
    background-size: 17px 17px;
    background-position: 18px center;
    padding-left: 40px;
    padding-right: 20px;
    text-align: left;
    width: auto;
    display: inline-block;
    background-repeat: no-repeat;
  }
}

@keyframes moveRight {
  from {
    left: 0;
  }
  to {
    left: 100%;
  }
}

.name-wrap {
  width: 100%;
  height: 26px;
  line-height: 26px;
  border-top: 1px solid rgba(202, 210, 214, 0.6);
  .name-icon {
    display: inline-block;
    vertical-align: top;
    margin-top: 5px;
    margin-left: 5px;
    width: 16px;
    height: 16px;
    background-image: url("../../assets/remote/dot.svg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .name-text {
    display: inline-block;
    vertical-align: top;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    color: #999999;
  }
}
</style>